import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faLeftRight } from "@fortawesome/free-solid-svg-icons";
import InfoTooltip from "../../../InfoTooltip";
import StudentInfoTooltip from "../../../StudentInfoTooltip";
import TipButton from "../../../TipButton";
import CategoryTags from "./CategoryTags";
import { handleScoreChange } from "./helpers/scoreHelpers";
import RichTextEditor from "./helpers/RichTextEditor";
import "./OpenTextQuestion.css";

const OpenTextQuestion = ({
  onChange,
  border,
  isStudentView,
  studentResponse,
  questionId,
  tip,
  score,
  questionCategories = [],
  content = "",
  showCategories = true,
  onFlip,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [tempResponse, setTempResponse] = useState(
    studentResponse?.answer || ""
  );
  const [tempInstructions, setTempInstructions] = useState(content);
  const [isEditingInstructions, setIsEditingInstructions] = useState(false);

  const handleClick = () => {
    setTempResponse(studentResponse?.answer || "");
    setIsEditing(true);
  };

  const handleInstructionsClick = () => {
    setTempInstructions(content);
    setIsEditingInstructions(true);
  };

  const handleSave = () => {
    if (isStudentView) {
      onChange({
        type: "OpenText",
        questionId: questionId,
        answer: tempResponse,
        status: "Pending",
        grade: {
          score: 0,
          feedback: "",
          gradedAt: null,
          gradedBy: null,
        },
      });
    }
    setIsEditing(false);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handleInstructionsSave = () => {
    onChange({
      content: tempInstructions,
    });
    setIsEditingInstructions(false);
  };

  const handleInstructionsCancel = () => {
    setIsEditingInstructions(false);
  };

  const onScoreChange = handleScoreChange(onChange);

  return (
    <div className={`question-container ${border || ""}`}>
      <div className="open-text-response">
        <div className="question-header">
          {isStudentView ? (
            <>
              <div className="question-display">
                {content ? (
                  <div
                    className="question-content"
                    dangerouslySetInnerHTML={{ __html: content }}
                  />
                ) : (
                  <div className="empty-question-placeholder">
                    <p>No instructions provided.</p>
                  </div>
                )}
              </div>
              <StudentInfoTooltip type="OpenText" />
            </>
          ) : (
            <>
              <div className="teacher-instructions">
                {!isEditingInstructions ? (
                  <div
                    className="instructions-display"
                    onClick={handleInstructionsClick}
                    style={{ cursor: "pointer" }}
                  >
                    {content ? (
                      <div
                        className="question-content"
                        dangerouslySetInnerHTML={{ __html: content }}
                      />
                    ) : (
                      <div className="empty-text-placeholder">
                        <FontAwesomeIcon icon={faPen} />
                        <p>Click here to add instructions</p>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="instructions-editor">
                    <RichTextEditor
                      value={tempInstructions}
                      onChange={setTempInstructions}
                      onSave={handleInstructionsSave}
                      onCancel={handleInstructionsCancel}
                      placeholder="Enter instructions for your students here..."
                    />
                  </div>
                )}
              </div>
              <InfoTooltip type="OpenText" />
            </>
          )}
        </div>
        {isStudentView && (
          <div className="student-response-area">
            {!isEditing ? (
              <div
                className="student-response-section"
                onClick={handleClick}
                style={{ cursor: "pointer" }}
              >
                {studentResponse?.answer ? (
                  <div
                    className="student-response-content"
                    dangerouslySetInnerHTML={{ __html: studentResponse.answer }}
                  />
                ) : (
                  <div className="empty-text-placeholder">
                    <FontAwesomeIcon icon={faPen} />
                    <p>Click here to write your response</p>
                  </div>
                )}
              </div>
            ) : (
              <div className="student-response-editor">
                <RichTextEditor
                  value={tempResponse}
                  onChange={setTempResponse}
                  onSave={handleSave}
                  onCancel={handleCancel}
                  placeholder="Write your response here..."
                />
              </div>
            )}
          </div>
        )}
        {!isStudentView && showCategories && (
          <div className="category-tags-container">
            <CategoryTags
              categories={questionCategories}
              onChange={(newCategories) =>
                onChange({
                  questionCategories: newCategories,
                })
              }
              isStudentView={isStudentView}
              showCategories={showCategories}
            />
          </div>
        )}
        <div className="question-footer">
          <div className="question-footer-flex">
            <div className="button-wrapper"></div>
            <TipButton
              tip={tip}
              onChange={onChange}
              isStudentView={isStudentView}
              onFlip={onFlip}
            />
            <div className="scorebox-container">
              <label htmlFor="score">Score:</label>
              <input
                type="number"
                id="score"
                value={score}
                onChange={onScoreChange}
                min="0"
                step="1"
                readOnly={isStudentView}
                className={isStudentView ? "student-view" : ""}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpenTextQuestion;
